import { Logger } from '../02_utils/logger';
import { Utils } from '../02_utils/utils';

export class Base {
  private offset: number;

  constructor(private $log: Logger, private $utils: Utils, private scrollOffset: number = 200) {
    this.offset = scrollOffset;
    this.anchorNavigation(this.offset);
  }

  /**
   * Scrolls to an anchor on click
   * All Anchor Links have a js-anchor-link class default.
   * @param offset the scrolling offset e.g. the height of the navbar
   */
  public anchorNavigation(offset: number): void {
    const anchorLinks: NodeListOf<HTMLElement> = document.querySelectorAll('.js-anchor-link');
    const urlHash: string = window.location.hash;

    if (anchorLinks) {
      anchorLinks.forEach((anchor) => {
        anchor.addEventListener('click', (event) => {
          event.preventDefault();
          const target = anchor.getAttribute('href');

          let targetElement: HTMLElement = document.querySelector(`.js-anchor-target[data-target="${target}"]`);
          if (!targetElement) {
            targetElement = document.querySelector(`.js-anchor-target[data-area-name="${target.replace('#', '')}"]`);
          }
          if (targetElement) {
            this.scrollToElement(targetElement, offset);
          }

        });
      });
    }

    if (urlHash) {
      const target: HTMLElement = document.querySelector(urlHash);
      const targetAnchor: HTMLElement = document.querySelector(`.js-anchor-target[data-area-name="${urlHash.replace('#', '')}"]`);

      if (target) {
        this.scrollToElement(target, offset);
      } else if (targetAnchor) {
        this.scrollToElement(targetAnchor, offset);
      }
    }
  }

  /**
   * Scrolls to a Element
   * @param targetElement the element to scroll to
   * @param offset the scroll offset e.g. the height of the navbar
   */
  private scrollToElement(targetElement: HTMLElement, offset: number) {
    const y = targetElement.getBoundingClientRect().top + window.scrollY - offset;
    this.$log.debug('BASE: scrollToElement', targetElement, y);
    window.scroll({
      top: y,
      behavior: 'smooth',
    });
  }
}
